import { moreThanNMinutesAgo } from '@/services/time'
import { IBaseDocument, Timestamp } from './base'
import { AwsRegion, UserIdentifier } from './user'

export type Codename = string

export interface IWorkstationDocument extends WorkstationDocumentCreate, IBaseDocument {}

type CloudServiceProvider = 'aws' | 'azure'

export type BillingInterval = {
  payment_intent_id: string
  amount_to_capture: number
  created: Timestamp
  duration_in_seconds: number
  paid: boolean
  authorized: boolean // whether it was possible to block funds
}

export interface WorkstationSpecs {
  cpu: string
  gpu: string
  ram: string
  root_volume: string
}

export type WorkstationStatus =
  // AWS states:
  | undefined // from state at launch
  | 'pending'
  | 'running'
  | 'shutting-down'
  | 'terminated'
  | 'stopping'
  | 'stopped'
  | 'rebooting'
  // Custom states:
  | 'preparing'
  | 'error'

export interface WorkstationDocument extends IWorkstationDocument {
  getTGXHostname(): string
  getRDPHostname(): string
  setupInProgress(): boolean
}

export interface WorkstationDocumentCreate {
  billing_intervals?: BillingInterval[]
  codename: Codename
  csp: CloudServiceProvider
  display_error: string
  hostname: string // private, ephemeral (AWS is changing it on every stop / start)
  instance_id: string
  internal_error: string
  is_billed_hourly: boolean
  name: string
  owner_id: UserIdentifier
  password: string
  port: string
  price_per_hour_usd: string
  public_hostname: string
  region?: AwsRegion
  secret_access_token: string
  setup_finished_timestamp: number | undefined
  specs: WorkstationSpecs
  status: WorkstationStatus
  teradici_agent_version?: string
  // We can forget about these (in connector as well)
  storage_gateway_instance_ids: Array<string>
  tgx_enabled: boolean
  tgx_sender_fingerprint: string
  user_id: UserIdentifier
  username: string
  windows_hostname: string
  modification_deadline_timestamp?: number // not used anymore
  block_stoppage_access: boolean
}

export class WorkstationDocument {
  public constructor(props: IWorkstationDocument) {
    Object.assign(this, props)
  }
  public getTGXHostname(): string {
    return this.public_hostname || this.hostname
  }
  public getRDPHostname(): string {
    return this.hostname
  }
  public setupInProgress(): boolean {
    if (this.status === 'error') {
      return false
    }
    if (this.password && (!this.created || moreThanNMinutesAgo(this.created, 90))) {
      return false
    }
    return !this.setup_finished_timestamp
  }

  public isActive(): boolean {
    return !this.deleted && this.status !== 'error'
  }
}
